// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import bmap from 'vue-baidu-map'
import echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import i18n from './lang' // Internationalization
import store from './store'
import axios from "./utils/request";
import '@/icons' // icon
import '@/permission' // permission control
import VueLocalStorage from 'vue-localstorage'
import promission from '@/utils/promission_request.js'
import permissionbutton from '@/directive/permission/button.js'
import 'font-awesome/css/font-awesome.css'

Vue.prototype.$echarts = echarts
Vue.prototype.$bmap = bmap
Vue.prototype.$http = axios
Vue.config.productionTip = false

// 修改 el-dialog 默认点击遮照为不关闭
//ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.use(permissionbutton)
Vue.use(promission);

Vue.use(VueLocalStorage)
    // Or you can specify any other name and use it via this.$ls, this.$whatEverYouWant
Vue.use(VueLocalStorage, {
    name: 'ls',
    bind: true //created computed members from your variable declarations
})

Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js